import { Component } from '@angular/core';
import { NewModalRef } from 'outshared-lib';
import { contactQueryParams } from '@inshared/shared/util';
import { AppRoutesEnum, ContactCategoryEnum, ContactSubjectEnum } from '@inshared/shared/core';

/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
@Component({
    selector: 'ins-decease-modal',
    templateUrl: './decease.modal.html'
})
export class DeceaseModal {
    constructor(
        private activeModal: NewModalRef<DeceaseModal>
    ) { }

    public close(): void {
        this.activeModal.close();
    }

    protected readonly contactQueryParams = contactQueryParams;
    protected readonly AppRoutesEnum = AppRoutesEnum;
    protected readonly ContactCategoryEnum = ContactCategoryEnum;
    protected readonly ContactSubjectEnum = ContactSubjectEnum;
}
